import useSkipModules from '~/composables/useSkipModules';

export default defineNuxtPlugin((nuxt) => {
  const { skipModule, moduleNames } = useSkipModules(nuxt._route);
  if (skipModule(moduleNames.AD)) {
    return;
  }
  useHead({
    script: [
      {
        key: 'live-wrapped',
        src: 'https://lwadm.com/lw/pbjs?pid=3e96150e-4822-476e-adc5-fb9aa76f97d6',
        async: true
      }
    ]
  });
});
